import { InviteFormFields, InviteFormValues, PeoPayrollProvider } from './types';

export const PEO_PAYROLL_PROVIDER_INITIAL_VALUES: PeoPayrollProvider = {
  email: '',
  isRevenueShareEnabled: false,
};

export const INITIAL_VALUES: InviteFormValues = {
  [InviteFormFields.peoPayrollProviders]: [PEO_PAYROLL_PROVIDER_INITIAL_VALUES],
};
